import { FC } from 'react';
import { reduxTypedHooks, userSharedSelectors } from 'common/modules/ReactShared';
import StudentFlag from './StudentFlag';

interface IProps {
  className?: string;
}

/**
 * The signed-in student's own flag: their nationality where they stated one, their
 * support language's otherwise — the same rule every classmate and teacher sees them by.
 */
const CurrentStudentFlag: FC<IProps> = ({ className }) => {
  const profile = reduxTypedHooks.useTypedSelector(userSharedSelectors.selectProfile);
  const supportLanguage = reduxTypedHooks.useTypedSelector(
    userSharedSelectors.selectProfileCurrentSupportLanguageInfo
  );

  if (!profile) return null;

  return (
    <StudentFlag
      className={className}
      nationality={profile.nationality}
      supportLanguageCode={supportLanguage?.code}
    />
  );
};

export default CurrentStudentFlag;
